<template>
  <div class="header-tabs" ref="headerTabs">
    <div class="tab-button" ref="leftButton">
      <a-icon v-show="showScrollButton && showScrollLeft" type="left" />
    </div>

    <div class="middle-scroll-box" ref="scrollBox">
      <div class="header-tab" :class="{'active-header-tab':activeMenu.MENU_ID === menu.MENU_ID}"
           v-for="menu in tabList" :key="menu.MENU_ID" @click="$goPath(menu)">
        {{ menu.MENU_NAME }}
        <a-icon v-if="menu.ASSEMBLY !== '/index'" type="close" @click="e=>removeClick(menu.MENU_ID,e)"></a-icon>
      </div>
    </div>

    <div class="tab-button" ref="rightButton">
      <a-icon v-show="showScrollButton && showScrollRight" type="right" />
    </div>
  </div>
</template>

<script>

import Sortable from 'sortablejs';
import elementResize from 'element-resize-detector';

export default {
  name: "the-menu-tab",
  data() {
    return {
      // 拖拽相关配置项
      sortConfig: {
        group: 'headerTabs',
        ghostClass: 'on-drag-doing',
        onEnd: ({ oldIndex, newIndex }) => {
          this.$store.commit('tabSortChange', { oldIndex, newIndex });
        },
      },
      sortable: null,
      // 滚动
      scrollBox: {},
      showScrollButton: false,
      showScrollLeft: false,
      showScrollRight: false,
      // 连续滚动事件
      scrollInterval: null,
      speed: 16, // 每帧运动的px
    };
  },
  computed: {
    tabList() {
      this.$nextTick(this.scrollButtonChange);
      return this.$store.state.menuTab;
    },
    activeMenu() {
      this.$nextTick(this.scrollIntoView);
      return this.$store.state.menuActive;
    },
  },
  methods: {
    scrollLeft() {
      this.scrollInterval = setInterval(() => {
        this.scrollBox.scrollLeft -= this.speed;
        if (this.scrollBox.scrollLeft <= 0) {
          this.scrollStop();
        }
      }, 16.7);
    },
    scrollRight() {
      this.scrollInterval = setInterval(() => {
        this.scrollBox.scrollLeft += this.speed;
        if (this.scrollBox.scrollLeft >= (this.scrollBox.scrollWidth - this.scrollBox.clientWidth)) {
          this.scrollStop();
        }
      }, 16.7);
    },
    scrollStop() {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    },
    removeClick(menuId, event) {
      if (event.altKey || event.ctrlKey || event.shiftKey) {
        return this.removeOtherTab(menuId);
      } else {
        return this.removeTab(menuId);
      }
    },
    removeTab(menuId) {
      if (this.activeMenu.MENU_ID === menuId) {
        const index = this.tabList.findIndex(m => m.MENU_ID === menuId);
        this.$goPath(this.tabList[index - 1]);
      }
      this.$store.commit('removeMenuTab', menuId);
    },
    removeOtherTab(menuId) {
      if (this.activeMenu.MENU_ID !== menuId) {
        const index = this.tabList.findIndex(m => m.MENU_ID === menuId);
        this.$goPath(this.tabList[index]);
      }
      this.$store.commit('removeOtherMenuTab', menuId);
    },
    scrollIntoView() {
      const domArr = document.getElementsByClassName('active-header-tab');
      try {
        domArr[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      } catch (e) {
      }
    },
    scrollButtonChange() {
      this.showScrollButton = this.scrollBox.scrollWidth > this.scrollBox.clientWidth;
      this.showScrollLeft = this.scrollBox.scrollLeft > 0;
      this.showScrollRight = this.scrollBox.scrollLeft < (this.scrollBox.scrollWidth - this.scrollBox.clientWidth);
    },
    init() {
      // 拖拽事件
      this.sortable = Sortable.create(this.$refs.scrollBox, this.sortConfig);
      // 滚动区域 滚动事件绑定
      this.scrollBox = this.$refs.scrollBox;
      this.scrollBox.onscroll = this.scrollButtonChange;
      elementResize().listenTo(this.$refs.headerTabs, this.scrollButtonChange);
      // 按钮事件绑定
      this.$refs.leftButton.onmousedown = this.scrollLeft;
      this.$refs.leftButton.onmouseup = this.scrollStop;
      this.$refs.leftButton.onmouseleave = this.scrollStop;
      this.$refs.rightButton.onmousedown = this.scrollRight;
      this.$refs.rightButton.onmouseup = this.scrollStop;
      this.$refs.rightButton.onmouseleave = this.scrollStop;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/headerTabs";
</style>
